import React from "react";
import { connect } from "react-redux";
import Menu from "../menu";
import { Button, Icon, Input, Modal, Pagination, Select, Table } from "../../components";
import { axios, Globals } from "../../utils";
import AddIcon from '../../assets/icons/add.png';
import ModalCreate from './modal-create-edit-route';

const INITIAL_FORM = {
  search: "",
  state_id: "",
  zone_id: "",
  method_id: "",
}

class Routes extends React.Component {

  state = {
    header: ['Nombre de la Ruta','ID de la Ruta','Zona(s) de despacho','Acciones'],
    page: 1,
    last_page: 1,
    data: [],
    form: INITIAL_FORM,
    user_id: this.props.user.id,
    item: null,
    visible: false,
    visible_create: false,
  };

  componentDidMount() {
    this.fetchData();
  };

  fetchData = (page = 1) => {
    let { form } = this.state;

    form.user_id = this.props.user.id;

    axios
      .post("admin/dispatchroute?page=" + page, form)
      .then(res => {
        this.setState({
          page,
          last_page: res.data.data.last_page,
          data: res.data.data.data,
        });
      })
      .catch(() => {
        Globals.showError();
      });
  };

  change = (value, target) => {
    this.setState({
      form: {
        ...this.state.form,
        [target]: value
      }
    });
  };

  cleanFilters = async () => {
    this.setState({ form: INITIAL_FORM });
  }

  view = (item) => {
    this.setState({ visible: true, item });
  }

  create = () => {
    this.setState({ visible_create: true, item: null });
  }

  edit = (item) => {
    this.setState({ visible_create: true, item });
  }

  delete = (id) => {
    Globals.confirm('¿Desea eliminar esta ruta?', () => {
      Globals.setLoading();
      axios.post('admin/dispatchroute/delete', { id })
      .then(res => {
        Globals.showSuccess(`Ruta eliminada con exito`);
        this.fetchData();
      })
      .catch(() => Globals.showError())
      .finally(() => Globals.quitLoading())
    })
  }

  close = () => {
    this.setState({
      visible: false,
      visible_create: false,
      item: null
    });
  }

  render() {
    const { form, visible, visible_create } = this.state;

    return (
      <Menu history={this.props.history}>
        {
          visible_create && (
            <Modal
              className="modal-create-route"
              title={this.state.item ? `Editar ruta de despacho` : `Nueva ruta de despacho`}
              size="lg"
              onClose={this.close}
              visible
            >
              <ModalCreate
                item={this.state.item}
                onClose={() => {
                  this.close();
                  this.fetchData();
                }}
              />
            </Modal>
          )
        }

        {
          visible && (
            <Modal
              className="modal-view-route"
              title="Zonas de despacho"
              size="sm"
              onClose={this.close}
              visible
            >
              <ModalView item={this.state.item} onClose={this.close} />
            </Modal>
          )
        }

        <div id="visit-planner">
          <div className="row">
            <div className="col-3">
              <Input
                color=" "
                label="Buscar"
                placeholder="ID o nombre de la ruta"
                className="filter"
                labelClass="filter"
                value={this.state.form.search }
                onChange={e => this.change(e.target.value, 'search')}
              />
            </div>
            <div className="col-2">
              <Select
                color="white"
                label="Zonas"
                placeholder="Todos"
                className="filter"
                labelClass="filter"
                options={[]}
                value={this.state.form.zone_id}
                onChange={e => this.change(e.target.value, 'zone_id')}
              />
            </div>
            <div className="col-2">
              <Select
                color="white"
                label="Forma de pago"
                placeholder="Todos"
                className="filter"
                labelClass="filter"
                options={[]}
                value={this.state.form.method_id}
                onChange={e => this.change(e.target.value, 'method_id')}
              />
            </div>

            <div className="col-3 row">
              <Button
                className="btn-align-bottom btn-filter mr-3"
                color="blue"
                onClick={() => this.fetchData()}
              >
                <span className="text-white">Filtrar</span>
              </Button>

              {
                (form.search !== '' || form.zone_id !== '' || form.method_id !== '') && (
                  <Button
                    className="btn-align-bottom btn-filter"
                    color=" "
                    onClick={async () => {
                      await this.cleanFilters();
                      this.fetchData();
                    }}
                  >
                    <span>Limpiar</span>
                  </Button>
                )
              }
            </div>
          </div>

          <Table
            data={this.state.data.length}
            header={this.state.header}
            right={
              <img src={AddIcon} width={32} alt="Agregar" onClick={() => this.setState({ visible_create: true })} />
            }
          >
            {this.state.data.map((i, index) => {
              return (
                <tr key={index}>
                  <td>{ i.description }</td>
                  <td>{ i.id }</td>
                  <td>
                    <div onClick={() => this.view(i)} style={{ cursor: 'pointer' }}>
                      <Icon name="eye" />
                    </div>
                  </td>
                  <td>
                    <Button
                      title="Editar"
                      small="true"
                      color="primary"
                      onClick={() => this.edit(i)}
                    >
                      <Icon name="edit" />
                    </Button>
                    <Button
                      title="Eliminar"
                      small="true"
                      color="red"
                      onClick={() => this.delete(i.id)}
                    >
                      <Icon name="trash" />
                    </Button>
                  </td>
                </tr>
              );
            })}
          </Table>

          <Pagination
            pages={this.state.last_page}
            active={this.state.page}
            onChange={page => this.fetchData(page)}
          />
        </div>
      </Menu>
    );
  }
}

const ModalView = ({ item }) => {
  return (
    <div className="route-list">
      {item?.details?.map((route, index) => (
        <p key={index} className="route-item">{ route?.zone?.name }</p>
      ))}
    </div>
  );
}

export default connect(state => {
  return {
    user: state.user
  };
})(Routes);
